<template>
    <div class="activityPage" :class="[$t('common.fontFamily'), $t('common.lang'), $t('common.type')]">
        <page-navigate></page-navigate>
        <div :id="'section1-' + $t('common.lang')" id="section1" class="acticity-list-session1 section1"
            style="cursor: pointer;" @click="toPath({ url: '/pay' })">
            <h1 v-html="$t('activityList.pageTitleH1')">
            </h1>
            <h2>{{ $t('activityList.pageTitleH2') }}</h2>
        </div>
        <div class="acticity-list-session2">
            <div class="activity-list-top-menu-box">
                <div class="activity-list-top-menu">
                    <div v-for="(menu, index) in $t('activityList.activityListMetaData')" :key="index"
                        class="activity-list-top-menu-item "
                        :class="[$t('common.fontFamilyTitle'), { 'activity-list-top-menu-item-selected': index == currentmenu }]"
                        @click="handleCheckoutMenu(index)">
                        {{ menu.label }}
                    </div>
                </div>
            </div>
            <div class="activity-list-wrapper">
                <div class="activity-list-time-line-wrapper pc">
                    <div class="activity-list-time-line-list">
                        <div class="activity-list-time-line-list-inner">
                            <template v-for="(item, index) in currentData">
                                <a class="activity-list-time-line-link"
                                    :class="{ 'activity-list-time-line-link-active': computedActivity(index) }"
                                    href="javascript:void(0)" v-if="item.time" @click="scrollTo('#tag' + item.id)"><span
                                        class="iconfont icon-Vector"></span>{{ item.time }}</a>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="activity-list-banner-box">

                    <div class="activity-list-banner-list">
                        <div class="activity-list-banner-item" v-for="(item, index) in currentData" :key="index"
                            :id="'tag' + item.id" @click="toPath(item)">
                            <div class="listBox">
                                <img class="activity-list-banner-item-img" :src="item.img" alt="" />
                                <div class="listContent" :class="item.bannerBoxClass">
                                    <div class="title" v-if="item.bannerTitle" :class="item.bannerTitleClass"
                                        v-html="item.bannerTitle">
                                    </div>
                                    <div class="subTitle" v-if="item.bannerSubTitle" :class="item.bannerSubTitleClass"
                                        v-html="item.bannerSubTitle"></div>
                                    <svg v-if="item.id == '2-4'" xmlns="http://www.w3.org/2000/svg" width="49"
                                        height="18" viewBox="0 0 49 18" fill="none">
                                        <path
                                            d="M0.816406 1.00488C0.816406 0.113973 1.89347 -0.332119 2.52344 0.297846L10.3145 8.08788C10.7049 8.4783 10.7047 9.1114 10.3145 9.50195L2.52344 17.293C1.89347 17.9229 0.816406 17.4768 0.816406 16.5859V1.00488ZM19.9551 1.00488C19.9551 0.113973 21.0321 -0.332119 21.6621 0.297846L29.4521 8.08788C29.8427 8.47841 29.8427 9.11142 29.4521 9.50195L21.6621 17.293C21.0321 17.9229 19.9551 17.4768 19.9551 16.5859V1.00488ZM39.0928 1.00488C39.0928 0.113973 40.1698 -0.332119 40.7998 0.297846L48.5908 8.08788C48.9813 8.47834 48.9811 9.11141 48.5908 9.50195L40.7998 17.293C40.1698 17.9228 39.0928 17.4768 39.0928 16.5859V1.00488Z"
                                            fill="url(#paint0_linear_1029_14488)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_1029_14488" x1="81.039" y1="8.7954"
                                                x2="-30.2213" y2="8.7954" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#5D2333" />
                                                <stop offset="1" stop-color="#5D2333" stop-opacity="0" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                            </div>

                            <div class="activity-list-banner-item-intro">
                                <div>
                                    <div class="activity-list-banner-item-title" :class="$t('common.fontFamilyTitle')">
                                        {{ item.title }}
                                    </div>
                                    <div class="activity-list-banner-item-subtitle">
                                        {{ item.subtitle }}
                                    </div>
                                </div>
                                <a v-if="item.url" href="javascript:;" class="activity-list-banner-item-more">
                                    {{ $t("activityList.了解更多") }}<span class="iconfont icon-chevron-right"></span>
                                </a>
                                <a v-else class="activity-list-banner-item-more" style="color: #aaa;"
                                    href="javascript:;">{{
                                        $t("activityList.敬请期待") }}</a>
                            </div>
                        </div>
                    </div>
                    <div class="activity-list-pagination">
                        <div class="pagination-left" @click="handlePrev">
                            <span class="iconfont icon-pagination-left"></span>
                        </div>
                        <div class="pagination-pages">
                            <div class="pagination-page-number"
                                :class="{ 'pagination-page-number-selected': index + 1 == currentpage }"
                                v-for="(item, index) in pages" :key="index" @click="changePage(index)">
                                {{ index + 1 }}
                            </div>
                        </div>
                        <div class="pagination-right" @click="handleNext">
                            <span class="iconfont icon-pagination-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="slogan-box">
            <div>{{ $t("activityList.每个认真交易的人") }}</div>
            <div>Where your goals begin</div>
        </div>
        <page-footer></page-footer>
    </div>
</template>
<script>
let PAGE_NAVIGATE_HEIGHT = 86;
function throttle(func, delay) {
    var timer = null;
    return function () {
        var that = this;
        var args = arguments;
        if (!timer) {
            timer = setTimeout(function () {
                func.call(that, args);
                timer = null;
            }, delay);
        }
    };
}
/**
 * 获取路由中的路由参数
 * @param urls
 * @returns {{}}
 */
function getAllUrlParams(urls) {
    var url = urls || location.href;
    // 用JS拿到URL，如果函数接收了URL，那就用函数的参数。如果没传参，就使用当前页面的URL
    var queryString = url ? url.split("?")[1] : window.location.search.slice(1);
    // 用来存储我们所有的参数
    var obj = {};
    // 如果没有传参，返回一个空对象
    if (!queryString) {
        return obj;
    }
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split("#")[0];
    // 将参数分成数组
    var arr = queryString.split("&");
    for (var i = 0; i < arr.length; i++) {
        // 分离成key:value的形式
        var a = arr[i].split("=");
        // 将undefined标记为true
        var paramName = a[0];
        var paramValue = typeof a[1] === "undefined" ? true : a[1];
        if (paramName.match(/\[(\d+)?\]$/)) {
            // 如果paramName不存在，则创建key
            var key = paramName.replace(/\[(\d+)?\]/, "");
            if (!obj[key]) obj[key] = [];
            // 如果是索引数组 e.g. colors[2]
            if (paramName.match(/\[\d+\]$/)) {
                // 获取索引值并在对应的位置添加值
                var index = /\[(\d+)\]/.exec(paramName)[1];
                obj[key][index] = paramValue;
            } else {
                // 如果是其它的类型，也放到数组中
                obj[key].push(paramValue);
            }
        } else {
            // 处理字符串类型
            if (!obj[paramName]) {
                // 如果如果paramName不存在，则创建对象的属性
                obj[paramName] = paramValue;
            } else if (obj[paramName] && typeof obj[paramName] === "string") {
                // 如果属性存在，并且是个字符串，那么就转换为数组
                obj[paramName] = [obj[paramName]];
                obj[paramName].push(paramValue);
            } else {
                // 如果是其它的类型，还是往数组里丢
                obj[paramName].push(paramValue);
            }
        }
    }
    return obj;
}
export default {
    data() {
        return {
            currentmenu: 0,
            currentpage: 1,
            pageSize: 10,
            total: 0,
            scrollTop: 0,
            lineList: [],
            init: false,
        };
    },
    computed: {
        dataMeta() {
            return this.$t("activityList.activityListMetaData");
        },
        pages() {
            let pages = Math.ceil(this.total / this.pageSize);
            if (pages <= 0) {
                return 1;
            } else {
                return pages;
            }
        },
        currentData() {
            return this.dataMeta[this.currentmenu].list.slice(
                (this.currentpage - 1) * this.pageSize,
                this.currentpage * this.pageSize
            );
        },
    },
    created() { },
    mounted() {
        let params = getAllUrlParams(window.location.href);
        if (params.index) {
            this.handleCheckoutMenu(params.index);
        } else {
            this.handleCheckoutMenu(0);
        }
        this.scrollEventListener();
    },
    filters: {},
    methods: {
        toPath(item) {
            if (item.url) {
                if (item.target == "_blank") {
                    window.open(item.url, item.target);
                } else {
                    window.location.href = item.url;
                }
            }
        },
        handleCheckoutMenu(index) {
            if (index == this.currentmenu && this.init) {
                return;
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.init = true;
            this.currentmenu = index;
            this.currentpage = 1;
            this.total = this.dataMeta[this.currentmenu].list.length;
            this.getTopList();
        },
        changePage(index) {
            index = index + 1;
            if (this.currentpage == index) {
                return;
            }
            this.currentpage = index;
            this.scrollTo(".activity-list-banner-box");
        },
        handlePrev() {
            if (this.currentpage <= 1) {
                return;
            }
            this.currentpage--;
            this.scrollTo(".activity-list-banner-box");
        },
        handleNext() {
            if (this.currentpage >= this.pages) {
                return;
            }
            this.currentpage++;
            this.scrollTo(".activity-list-banner-box");
        },
        scrollTo(elementName) {
            const targetElement = document.querySelector(elementName);
            window.scrollTo({
                top: targetElement.offsetTop - PAGE_NAVIGATE_HEIGHT,
                behavior: "smooth",
            });
        },
        scrollEventListener() {
            let _this = this;
            window.addEventListener(
                "scroll",
                throttle(() => {
                    _this.scrollTop = document.documentElement.scrollTop;
                }, 300)
            );
        },
        computedActivity(index) {
            console.log("index", index)
            if (index == 0) {
                return this.scrollTop < this.lineList[1];
            } else if (index === this.lineList.length - 1) {
                // 最后一个元素的范围是 [lineList[index], Infinity)
                return this.scrollTop >= this.lineList[index];
            } else {
                return (
                    this.scrollTop < this.lineList[index + 1] &&
                    this.scrollTop >= this.lineList[index]
                );
            }
        },
        getTopList() {
            if (this.currentmenu == this.dataMeta.length - 2) {
                setTimeout(() => {
                    this.$nextTick(() => {
                        let arr = this.currentData.map((el) => {
                            return (
                                document.getElementById("tag" + el.id).offsetTop -
                                PAGE_NAVIGATE_HEIGHT - 1
                            );
                        });
                        this.lineList = arr;
                    });
                })

            }
        },
    },
}
</script>
<style>
.barca2526-title-box {
    max-width: unset !important;
    width: 60%;
}

.img-logo {
    height: 60rem;
}

.barca2526-title {
    margin-top: 30rem;
    font-size: 42rem;
    font-weight: 700;
    color: #fff;
}

.barca2526-title.en {
    font-size: 38rem;
}

.barca2526-title.jp {
    font-size: 30rem;
}

.barca2526-title span {
    color: #ff4b4e;
}

.img-arrow {
    margin-top: 16rem;
    width: 50rem;
}

.activity-list-banner-item .listContent .subTitle .red {
    color: #A52933;
    font-size: 68.332px;
    font-weight: 900;
    line-height: 50.148rem;
}

.section1 h1 .red,
#section1 h1 .red {
    color: #A52933;
    font-family: Inter;
    font-size: 64.102rem;
    font-style: normal;
    font-weight: 900;
    line-height: 53.327rem;

}

@media (min-width: 1921px) {
    .img-logo {
        height: 48px;
    }

    .barca2526-title {
        margin-top: 30px;
        font-size: 36px;
        font-weight: 700;
        color: #fff;
    }

    .barca2526-title.en {
        font-size: 28px;
    }

    .barca2526-title.jp {
        font-size: 30px;
    }


    .barca2526-title span {
        color: #ff4b4e;
    }

    .img-arrow {
        margin-top: 16px;
        width: 50px;
    }

    .eng .activity-list-banner-item .listContent .creator-incentives-title,
    .activity-list-banner-item .listContent .creator-incentives-title {
        color: var(--Text-Primary, #000);
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
        font-size: 50px;
        line-height: normal;
        font-style: normal;
        font-weight: 700;
        max-width: 460px;
    }
}




@media screen and (max-width: 1440px) {
    .activity-list-banner-item .listContent .subTitle .red {
        color: #A52933;
        font-size: 68.332rem;
        font-weight: 900;
        line-height: 50.148rem;
    }
}

@media screen and (max-width: 996px) {

    .section1 h1 .red,
    #section1 h1 .red {
        font-size: 46rem;
        line-height: 38rem;
        font-weight: 900;
    }

    .activity-list-banner-item .listContent .subTitle .red {
        color: #A52933;
        font-size: 56.332rem;
        font-weight: 800;
        line-height: 41.148rem;
        font-family: Inter;
    }
}
</style>

<style scoped>
@import url("../assets/css/rem.css");

@font-face {
    font-family: "Financier Display";
    src: url("../assets/font/FinancierDisplay-Bold.otf") format("opentype");
}



.acticity-list-session1 {
    position: relative;
    height: 350rem;
    background-image: url(../assets/image/activityList/bg.png);
    background-repeat: no-repeat;
    background-size: cover;
}

.section1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* background-image: url(../assets/image/activityList/bg_1.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center; */

}

#section1 {
    background-image: url(../assets/image/activityList/bg2.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

.section1 h1,
#section1 h1 {
    color: #5D2333;
    font-size: 44.667rem;
    font-style: normal;
    font-weight: 900;
    line-height: 53.327rem;
    text-align: left;
    padding-left: 306rem;
    max-width: 54vw;
    font-family: "Noto Sans SC", sans-serif;
}

.section1 h2,
#section1 h2 {
    color: #5D2333;
    font-size: 23.056rem;
    font-style: normal;
    font-weight: 350;
    line-height: normal;
    margin-top: 15rem;
    text-indent: 306rem;
    font-family: "Noto Sans SC", sans-serif;
}

/* #section1-zh {
    background-image: url(../assets/image/activityList/bg_2_zh.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

#section1-vi {
    background-image: url(../assets/image/activityList/bg_2_vi.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

#section1-th {
    background-image: url(../assets/image/activityList/bg_2_th.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

#section1-en {
    background-image: url(../assets/image/activityList/bg_2_en.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

#section1-ko {
    background-image: url(../assets/image/activityList/bg_2_kr.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}

#section1-jp {
    background-image: url(../assets/image/activityList/bg_2_jp.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
} */

/* .section1 h1 {
    display: flex;
    justify-content: center;
    color: #fff;
    text-align: center;
    text-shadow: 0rem 3.415rem 2.277rem rgba(0, 0, 0, 0.45);
    font-size: 55rem;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 0.558rem;
    gap: 4rem;
} */

.en .section1 h1 {
    font-size: 48rem;
}

.section1 h1 .ebc {
    font-size: 78.447rem;
    letter-spacing: 0.784rem;
    font-family: "Financier Display";
}


.subtitle {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12rem;
    color: #fff;
    text-align: center;
    font-size: 32rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1em;
    letter-spacing: 0.48rem;
    opacity: 0.7;
}

.en .subtitle {
    font-size: 20rem;
    font-weight: 500;
}

.title-icon {
    width: 30rem;
    height: 30rem;
}

.subtitle-line-left {
    height: 1px;
    max-width: 400rem;
    min-width: 30rem;
    flex: 1;
    background: linear-gradient(to left,
            rgba(255, 255, 255, 0.7),
            rgba(255, 255, 255, 0));
}

.subtitle .icon-Vector {
    font-size: 24rem;
}

.subtitle-line-right {
    height: 1px;
    flex: 1;
    max-width: 400rem;
    min-width: 30rem;
    background: linear-gradient(to right,
            rgba(255, 255, 255, 0.7),
            rgba(255, 255, 255, 0));
}

.acticity-list-session1-inner {
    margin: 0 auto;
    height: 100%;
    max-width: 1440px;
    display: flex;
    gap: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.acticity-list-session1-title {
    color: #fff;
    text-align: center;
    font-size: 50px;
    font-style: normal;
    font-weight: 900;
    line-height: 120%;
}

.acticity-list-session1-subtitle {
    color: #fff;
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 350;
    line-height: 140%;
}

.activity-list-wrapper {
    margin: 0 auto;
    max-width: 1440px;
    padding: 68px 260px 80px 40px;
}

.ar .activity-list-wrapper {
    padding: 68px 40px 80px 260px;
}

.activity-list-wrapper {
    /* position: relative; */
    width: 100%;
    display: flex;
}

.activity-list-time-line-wrapper {
    position: sticky;
    margin-top: 90px;
    margin-left: 50px;
    top: 200px;
    width: 190px;
    height: 100%;
    flex-shrink: 0;
}

.activity-list-time-line-list-inner {
    display: flex;
    flex-direction: column;
    gap: 30px;
    max-width: 250px;
}

.activity-list-time-line-list-inner::before {
    position: absolute;
    left: 0;
    top: 10px;
    content: "";
    width: 1px;
    height: calc(100% - 20px);
    background-color: #e6ddcf;
}

.activity-list-time-line-link {
    position: relative;
    padding-left: 20px;
    color: #5d2333;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    z-index: 999;
}

.activity-list-time-line-link:hover {
    color: #a52933;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
}

.activity-list-time-line-link .icon-Vector {
    position: absolute;
    left: -7px;
    top: 0;
    color: #e6ddcf;
}

.activity-list-time-line-link:hover .icon-Vector {
    color: #ff4b4e;
}

.activity-list-time-line-link-active {
    color: #a52933;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
}

.activity-list-time-line-link-active .icon-Vector {
    color: #ff4b4e;
}

.activity-list-banner-box {
    width: calc(100% - 240px);
    /* height: 2000px; */
    flex-shrink: 0;
    /* background-color: azure; */
}

.activity-list-banner-box .listBox {
    display: flex;
    align-items: center;
    width: 100%;
    aspect-ratio: 2.42;
    box-sizing: border-box;
    position: relative;
}

.activity-list-banner-box .listBox .activity-list-banner-item-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
}

.activity-list-top-menu-box {
    position: sticky;
    top: 80px;
    background: #fff;
    box-shadow: 0px 2px 10px 0px rgba(61, 1, 1, 0.08);
    z-index: 9;
}

.activity-list-top-menu {
    max-width: 1400px;
    padding: 0 260px;
    margin: 0 auto;
    display: flex;
    justify-content: center;

    /* margin-bottom: 15px; */
}

.activity-list-top-menu-item {
    cursor: pointer;
    padding: 25px 10px;
    text-align: center;
    color: #b2afad;
    font-size: 26px;
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
    width: 33.3%;
    /* border- */
    /* border-bottom: 1px solid #9f734c; */
    transition: color 0.4s;
}

.activity-list-top-menu-item:hover,
.activity-list-top-menu-item-selected {
    color: #A52933;
    padding-bottom: 24px;
    border-bottom: 2px solid #A52933;
}

.activity-list-banner-item {
    padding-top: 40px;
}

.activity-list-banner-item .listContent {
    max-width: 70%;
    padding-left: 55rem;
}

.activity-list-banner-item .listContent .title {
    color: #5D2333;
    font-size: 21.405px;
    font-weight: 400;
    line-height: normal;
    max-width: 100%;

}

.activity-list-banner-item .listContent .subTitle {
    font-family: "Noto Sans SC", sans-serif;
    color: #5D2333;
    font-size: 40.854px;
    font-weight: 700;
    line-height: 50.148px;
    /* 122.751% */
    margin: 15px 0 30px;
}

.activity-list-banner-item .listContent svg {
    width: 48.067px;
    height: 17.585px;
}

.activity-list-banner-item-img {
    /* margin-top: 40px; */
    /* height: 330px; */
    width: 100%;
    object-fit: cover;
}

.activity-list-banner-item-intro {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 30px 34px;
    background: #f9f6f2;
    gap: 20rem;
}

.activity-list-banner-item-title {
    color: #232222;
    font-size: 30px;
    font-style: normal;
    font-weight: 800;
    line-height: 120%;
    max-width: 500px;
}

.activity-list-banner-item-subtitle {
    margin-top: 17px;
    color: #6a6967;
    font-size: 18px;
    font-style: normal;
    font-weight: 350;
    line-height: 140%;
    max-width: 750px;
}

.activity-list-banner-item-more {
    display: flex;
    flex-shrink: 0;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: #9f734c;
    transition: all 0.4s;
}

.activity-list-banner-item-more .icon-chevron-right {
    color: #9f734c;
    font-size: 18px;
    margin-left: 10px;
    transition: all 0.4s;
}

.activity-list-banner-item-more:hover,
.activity-list-banner-item-more:hover .icon-chevron-right {
    color: #a52933;
}

/* 翻页 */
.activity-list-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;
    margin-top: 80px;
}

.activity-list-pagination .icon-pagination-left,
.activity-list-pagination .icon-pagination-right {
    cursor: pointer;
    font-size: 40px;
    color: #a52933;

    padding: 0 10px;
}

.pagination-pages {
    display: flex;
    align-items: center;
    gap: 20px;
}

.pagination-page-number {
    cursor: pointer;
    width: 40px;
    height: 40px;
    font-family: Gilroy;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    line-height: 40px;
    color: #a52933;
    /* background-color: #fff; */
    border-radius: 50%;
    transition: all 0.27s;
}

.pagination-page-number:hover,
.pagination-page-number-selected {
    background-color: #a52933;
    color: #fff;
    overflow: hidden;
}

.slogan-box {
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: #f9f6f2;
    padding: 28px;
    color: #3d0101;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
}

.eng .activity-list-banner-item .listContent .creator-incentives-title,
.activity-list-banner-item .listContent .creator-incentives-title {
    color: var(--Text-Primary, #000);
    font-family: "Inter", "Noto Sans", sans-serif !important;
    font-size: 40rem;
    line-height: normal;
    font-style: normal;
    font-weight: 700;
    max-width: 460rem;
}

.eng .activity-list-banner-item .listContent .creator-incentives-subtitle,
.activity-list-banner-item .listContent .creator-incentives-subtitle {
    color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
    font-family: "Inter", "Noto Sans", sans-serif !important;
    font-size: 14rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    max-width: 460rem;
    margin-top: 24rem;
    margin-bottom: 0;
}

@media (min-width: 1921px) {
    .activity-list-banner-item .listContent{
        padding-left: 55px;
    }
    
    .eng .activity-list-banner-item .listContent .creator-incentives-title,
    .activity-list-banner-item .listContent .creator-incentives-title {
        color: var(--Text-Primary, #000);
        font-family: "Inter", "Noto Sans", "Noto Sans SC", sans-serif !important;
        font-size: 50px;
        line-height: normal;
        font-style: normal;
        font-weight: 700;
        max-width: 460px;
    }
}


@media (max-width: 1440px) {
    .activity-list-banner-item .listContent .title {
        color: #5D2333;
        font-size: 21.405rem;
        font-weight: 400;
        line-height: normal;
    }

    .activity-list-banner-item .listContent .subTitle {
        color: #5D2333;
        font-size: 40.854rem;
        font-weight: 700;
        line-height: 50.148rem;
        /* 122.751% */
        margin: 15rem 0 30rem;
    }

    .activity-list-banner-item .listContent svg {
        width: 48.067rem;
        height: 17.585rem;
    }

    .eng .activity-list-banner-item .listContent .creator-incentives-title,
    .activity-list-banner-item .listContent .creator-incentives-title {
        color: var(--Text-Primary, #000);
        font-family: "Inter", "Noto Sans", sans-serif !important;
        font-size: 40rem;
        line-height: normal;
        font-style: normal;
        font-weight: 700;
        max-width: 460rem;
    }

    .eng .activity-list-banner-item .listContent .creator-incentives-subtitle,
    .activity-list-banner-item .listContent .creator-incentives-subtitle {
        color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
        font-family: "Inter", "Noto Sans", sans-serif !important;
        font-size: 14rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        max-width: 460rem;
        margin-top: 24rem;
        margin-bottom: 0;
    }
}

@media (max-width: 996px) {

    .section1,
    #section1 {
        height: 250rem;
        background-image: url(../assets/image/activityList/bg2m.png?v=1.1.1);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        padding-left: 60rem;
    }

    .ar .section1 h1 {
        text-align: right;
    }

    .section1 h1,
    #section1 h1 {
        text-indent: 0;
        color: #5D2333;
        font-size: 32rem;
        font-weight: 900;
        line-height: 38rem;
        max-width: 60%;
        padding: 0;
    }


    .section1 h2,
    #section1 h2 {
        text-indent: 0;
        color: #5D2333;
        font-size: 24rem;
        font-weight: 500;
        line-height: normal;
        max-width: 60%;

    }

    /* .section1 {
    height: 1270rem;
  } */
    /* .section1,
  #section1 {
    background-image: url(../assets/image/activityList/bg2m.jpg?v=1.1.1);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
    .section1 h1 {
        font-size: 39rem;
        line-height: 48rem;
    }

    .en .section1 h1 {
        font-size: 31rem;
    }

    .section1 h1 .ebc {
        font-size: 55rem;
        line-height: 55rem;
    }

    .subtitle {
        margin-top: 4rem;
        font-size: 24rem;
        font-weight: 500;
    }

    .en .subtitle {
        font-size: 16rem;
    }

    .cn .acticity-list-session1-title {
        font-size: 50px;
    }

    .acticity-list-session1-title {
        font-size: 40px;
    } */

    /* .acticity-list-session1 {
        padding: 0 24px;
    } */

    .activity-list-wrapper {
        padding: 44px 24px;
    }



    .activity-list-banner-item .listContent .title {
        font-size: 17.405rem;
    }

    .activity-list-banner-item .listContent .subTitle {
        font-size: 33.854rem;
        font-weight: 700;
        line-height: 40.148rem;
        /* 122.751% */
        margin: 12rem 0 22rem;
    }

    .activity-list-banner-item .listContent svg {
        width: 39.067rem;
        height: auto;
    }

    .activity-list-banner-box {
        width: 100%;
    }

    .activity-list-banner-item-img {
        width: 100%;
        height: auto;
    }

    .activity-list-top-menu-box {
        top: 80px;
    }

    .activity-list-top-menu {
        /* top: 80px; */
        padding: 0;
    }

    .cn .activity-list-top-menu-item {
        font-size: 18px;
        width: 33.3%;
    }

    .activity-list-top-menu-item {
        font-size: 16px;
        width: 50%;
    }

    .activity-list-banner-item-intro {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
    }

    .activity-list-banner-item-title {
        font-size: 22px;
    }

    .activity-list-banner-item-subtitle {
        margin-top: 20px;
        font-size: 16px;
    }

    .activity-list-banner-item-more {
        font-size: 16px;
    }

    .activity-list-pagination {
        gap: 40px;
    }

    .pagination-pages {
        gap: 14px;
    }

    .activity-list-pagination .icon-pagination-left,
    .activity-list-pagination .icon-pagination-right {
        font-size: 28px;
    }

    .pagination-page-number {
        width: 28px;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
    }

    .eng .activity-list-banner-item .listContent .creator-incentives-title,
    .activity-list-banner-item .listContent .creator-incentives-title {
        color: var(--Text-Primary, #000);
        font-family: "Inter", "Noto Sans", sans-serif !important;
        font-size: 38rem;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        max-width: 330rem;
    }

    .eng .activity-list-banner-item .listContent .creator-incentives-subtitle,
    .activity-list-banner-item .listContent .creator-incentives-subtitle {
        color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
        font-family: "Inter", "Noto Sans", sans-serif !important;
        font-size: 14rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        max-width: 310rem;
        margin-top: 24rem;
        margin-bottom: 0;
    }


}
</style>

<style lang="scss">
@media (max-width: 996px) {
    .activity-list-wrapper {
        .img-logo {
            height: 40rem;
        }

        .barca2526-title {
            margin-top: 16rem;
            font-size: 26rem;
        }

        .barca2526-title.en {
            font-size: 22rem;
        }

        .barca2526-title.jp {
            font-size: 18rem;
        }

        .barca2526-title span {
            color: #ff4b4e;
        }

        .img-arrow {
            width: 38rem;
        }

        .barca2526-title-box {
            max-width: unset !important;
            width: 360rem;
        }
    }
}
</style>